module.exports = {"body":"<p>Love to entertain? or is your kitchen just too small for your family? Let our designers help you create the kitchen of your dreams. At Enhanced Interiors Remodeling we work with custom cabinet makers, skilled craftsmen and excellent designers to help you envision and create the kitchen you have always wanted.</p>\n<p>Enhanced Interiors Remodeling will work for you.</p>\n"}


//////////////////
// WEBPACK FOOTER
// ./work/Kitchens.md
// module id = 514
// module chunks = 0